import { FunctionComponent } from 'react';

import NewImage from 'components/layout/NewImage';

import { Props } from './index';
import StyledComponent from './styles';

const PublicBlogsArticleSocials: FunctionComponent<Props> = ({ article, translations }) => {
    return (
        <StyledComponent className="public-blogs-article-socials">

            <div className="socials-title">
                {translations?.socialsTitle}
            </div>
            <div className="socials-icons">
                <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=https://depilacja.pl/blog/artykul/${article?.locale?.slug}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    <NewImage
                        className="icon"
                        src={'/images/article/article/fb.svg'}
                        alt="facebook-icon"
                    />
                </a>
                <a
                    href={`https://twitter.com/intent/tweet?url=https://depilacja.pl/blog/artykul/${article?.locale?.slug}`}
                    rel="noreferrer"
                    target="_blank"
                >
                    <NewImage
                        className="icon"
                        src={'/images/article/article/tweet.svg'}
                        alt="tweet-icon"
                    />
                </a>
            </div>
        </StyledComponent>
    );
};

export default PublicBlogsArticleSocials;
